import { HttpClient } from '@angular/common/http';
import { Directive, Injectable } from '@angular/core';
import { EndPointApi } from '@helpers/endpointapi';
import { Graph } from 'ops/common/models/graphs';
import { Observable } from 'rxjs';

@Directive()
@Injectable()
export class GraphsApiService {
    private domain: string;

    constructor(private http: HttpClient) {
        this.domain = EndPointApi.iApiDomain();
    }

    getAll(): Observable<Graph[]> {
        return this.http.get<Graph[]>(`${this.domain}/api/ops/graphs`);
    }
}
